import { LoanPropertyPurposeType } from './LoanPropertyPurposeType';

export const LoanPropertyPurposeTypeOptions = [
    {
        id: LoanPropertyPurposeType.NonAcquisition,
        name: 'Non-Accquisition',
    },
    {
        id: LoanPropertyPurposeType.Acquisition,
        name: 'Acquisition',
    },
    {
        id: LoanPropertyPurposeType.Refinance,
        name: 'Refinance',
    },
    {
        id: LoanPropertyPurposeType.BuildRent,
        name: 'Build-Rent',
    },
    {
        id: LoanPropertyPurposeType.FixRent,
        name: 'Fix-Rent',
    },
];
